<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <b-button>Button</b-button>
    <b-button variant="danger">Button</b-button>
    <b-button variant="success">Button</b-button>
    <b-button variant="outline-primary">Button</b-button>
    <router-link :to="{name:'bugoJang'}">부고장</router-link>
    <a id="custom-login-btn" @click="loginWithKakao()">
      <img
          src="//k.kakaocdn.net/14/dn/btroDszwNrM/I6efHub1SN5KCJqLm1Ovx1/o.jpg"
          width="222"
          alt="카카오 로그인 버튼"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      msg: 'BBBBBUUUGO'
    }
  },
  methods: {
    loginWithKakao() {
      window.Kakao.Auth.authorize({
        // redirectUri: 'http://localhost:8080/kakao-login-lending', // Require
        redirectUri: `${window.location.protocol}//${window.location.host}/kakao-login-lending`, // Require
      })
    }
  },
  created() {
    window.Kakao.init('bc686096e7d9fcf99c548e7c25d5b62d');
    console.log(window.Kakao.isInitialized());
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
